import { useState } from 'react';
import { TITULAR_SEED } from '../config/Config';

export function useCadernoCaseTeam(activeWorkspace) {
  const [editingCaseTeam, setEditingCaseTeam] = useState(false);
  const [caseTeamEdit, setCaseTeamEdit] = useState(() => {
    const raw = Array.isArray(activeWorkspace?.caseTeam) ? activeWorkspace.caseTeam : [];
    return raw.length > 0 ? raw : [{ ...TITULAR_SEED, addedAt: new Date().toISOString() }];
  });
  const [isCaseTeamPickerOpen, setIsCaseTeamPickerOpen] = useState(false);

  return {
    editingCaseTeam, setEditingCaseTeam,
    caseTeamEdit, setCaseTeamEdit,
    isCaseTeamPickerOpen, setIsCaseTeamPickerOpen,
  };
}
